export default "__VITE_ASSET__C8x6Jlvk__"